import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useI18n } from '../../contexts/I18nContext';

interface RequireAuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLoginClick: () => void;
}

const RequireAuthModal: React.FC<RequireAuthModalProps> = ({ isOpen, onClose, onLoginClick }) => {
  const { t } = useI18n();

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose}>
          <motion.div className="card w-full max-w-md overflow-hidden" initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} onClick={(e) => e.stopPropagation()}>
            <div className="p-6 text-center">
              <h3 className="text-xl font-bold mb-2">{t('loginToContinue')}</h3>
              <p className="text-gray-600 dark:text-gray-300 mb-6">{t('loginRequiredMessage')}</p>
              <div className="flex items-center justify-center gap-3">
                <button onClick={onClose} className="btn-secondary">{t('cancel')}</button>
                <button onClick={onLoginClick} className="btn-primary">{t('loginTitle')}</button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RequireAuthModal;


